import React, { useEffect, useState } from "react";

import {deleteMessage, deleteTestimonial, loadMessages,} from "../utils/Network";
import { Link } from "react-router-dom";

export default function MessagesContent({ page, urlParams }) {
  const [loading, setLoading] = useState(0);
  const [pageloading, setPageLoading] = useState(false);
  const [messages, setMessages] = useState(null);
  const [messages_count, setMessagesCount] = useState(null);
  const [show_delete, setShowDelete] = useState(false);
  const [pages, setPages] = useState(null);

  var filter_query = window.location.search;
  useEffect(() => {
    setPageLoading(true);
    getData();

    
  }, []);

  function getData() {
    //console.log(filter_query)
    loadMessages(filter_query, page).then((data) => {
      if (data.results) {
        setMessages(data.results);
      }
      if (data.count) {
        setMessagesCount(data.count);
        if (data && data.count) {
          var page_count =
            data.count % 10 === 0
              ? parseInt(data.count / 10)
              : parseInt(data.count / 10) + 1;
          var pages_array = range(1, page_count);
          setPages(pages_array);
        }
      }
      setPageLoading(false);
    });
  }
  function range(start, end) {
    return Array.apply(0, Array(end)).map((element, index) => index + start);
  }

  const handleDelete = (id, e) => {
    setLoading(id);
     deleteMessage(id).then(() => {
       getData();
     });
  };

  const showDelete = (e) => {
    e.preventDefault();
    setShowDelete(!show_delete);
  };


  return (
    <>
      <div className="content-wrapper">
        <section class="content-header">
          <h3 class="box-title mt-5"></h3>
          <ol class="breadcrumb">
            <li>
              <a href="/cms/dashboard">
                <i class="fa fa-dashboard"></i> Home
              </a>
            </li>
            <li class="active">Messages</li>
          </ol>
        </section>

        <section className="content">
          <div className="row">
            <div className="col-md-12">
              <div class="box box-primary">
                <div class="box-header with-border">
                  <h3 class="box-title">
                    All Items &nbsp;
                    <span style={{ fontSize: 11, marginLeft: '0.35em' }}>
                      ({messages_count}) items
                    </span>
                  </h3>
                  
                  <a
                    href="delete"
                    title="Show Delete Button"
                    className="btn btn-cm margin-r-5 pull-right "
                    onClick={showDelete}
                  >
                    <i className="fa fa-trash"></i>
                  </a>
                </div>
                <div className="box-body no-padding ">
                  <form action="" method="get">
                    <table id="example1" className="table table-striped mb-0">
                      <thead>
                        <tr>
                          <th></th>
                          <th>Subject</th>
                          <th>Status</th>
                          <th>Date</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {messages?.map((item) => (
                          <tr
                            key={item.id}
                            className={loading === item.id ? "loading" : ""}
                          >
                            <td>
                                {item.user && (
                                  <>
                                <div className="img-container ">
                                    <a  target="_blank" href={`/cms/usertalent/${item.user.profile.id}`}  >
                                        <img src={item.user.profile.image ? item.user.profile.image : "/assets/cms/assets/dist/img/avatar5.png"} className="pull-left width-60 img-list img-circle margin-r-10" alt="" />
                                    </a>
                                </div>

                                <a href={`/cms/usertalent/${item.user.profile.id}`} className="link-color kfont" >
                                    {item.user.profile.first_name &&
                                        <p>{item.user.profile.first_name} {item.user.profile.last_name}</p>
                                    }
                                    {!item.first_name &&
                                        <p>{item.user.profile.email}</p>
                                    }
                                </a>
                              </>)}
                            </td>
                            <td className="kfont">
                              <p>
                                <a href={`/cms/message/${item.id}`}>
                                  <b>{item.title}</b>
                                  <br />
                                  {item.message.slice(0,30)}
                                </a>
                              </p>
                            </td>
                            <td>
                               {item.status ? "Open" : "Closed"}
                            </td>
                            <td>
                              {item.created_at.split("T")[0]}
                              <br />
                              {item.created_at.split("T")[1].split(".")[0]}
                            </td>
                            <td>
                              <div className="btn-group">
                                {show_delete && (
                                  <button
                                    type="button"
                                    onClick={(e) => {
                                      if (
                                        window.confirm(
                                          "Are you sure you wish to delete this item?"
                                        )
                                      )
                                        handleDelete(item.id, e);
                                    }}
                                    className="btn btn-default btn-sm"
                                  >
                                    <i className="fa fa-trash"></i>
                                  </button>
                                )}
                                <a
                                  href={`message/${item.id}`}
                                  className="btn btn-default btn-sm mx-2"
                                >
                                  <i className="fa fa-edit "></i>
                                </a>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot>
                        <tr>
                          <th></th>
                          <th>Subject</th>
                          <th>Status</th>
                          <th>Date</th>
                          <th></th>
                        </tr>
                      </tfoot>
                    </table>
                  </form>
                </div>
              </div>
              {pages && pages.length > 1 &&
              <ul className="pagination cms-pagination m-0 float-right">
                <li className="page-item">
                  <Link className="page-link" to="#">
                    «
                  </Link>
                </li>
                {pages && pages.length > 1 &&
                  pages.map((page_number) => (
                    <li key={page_number} className="page-item">
                      <a
                        className={
                          page_number == page ? "page-link active" : "page-link"
                        }
                        href={`messages/${page_number}${
                          urlParams ? "?" + urlParams : ""
                        }`}
                      >
                        {page_number}
                      </a>
                    </li>
                  ))}
                <li className="page-item">
                  <Link className="page-link" to="">
                    »
                  </Link>
                </li>
              </ul>
              }
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
